<app-site-layout
  [filtersTpl]="filtersTpl"
  [leftControlsTpl]="leftControlsTpl"
  [rightControlsTpl]="rightControlsTpl"
  [contentTpl]="contentTpl"
  [companyId]="companyId"
  [pageRangeInfo]="page | asPageRangeInfo"
></app-site-layout>

<ng-template #filtersTpl>
  <app-processing-table-filters class="filters_component"></app-processing-table-filters>
</ng-template>

<ng-template #leftControlsTpl>
  <app-sites-add-buttons [companyId]="companyId"></app-sites-add-buttons>
</ng-template>

<ng-template #rightControlsTpl>
  <app-actions-buttons
    (archive)="archive()"
    (delete)="delete()"
    [disabled]="!selectedEntities.length"
    [archiveButtonLabel]="showArchived ? 'Unarchive processes' : 'Archive processes'"
    deleteButtonLabel="Delete processes"
  ></app-actions-buttons>
  <app-archive-mode-select
    *ngIf="hasPermission(permissions.CAN_ACCESS_ARCHIVED_PROCESSINGS)"
    [showArchived]="showArchived"
    (archiveChange)="changeArchiveSelect($event)"
  ></app-archive-mode-select>
  <button nbButton size="tiny" status="primary" class="sites-nav__refresh" (click)="onRefresh()">
    <nb-icon icon="refresh-outline"></nb-icon>
    Refresh
  </button>
</ng-template>

<ng-template #contentTpl>
  <app-processing-table></app-processing-table>
</ng-template>
